export default "__VITE_ASSET__f87824fe__"